import { useRef, useEffect } from 'react';
import useCerrarConEscapeYClickAfuera from '../../hooks/useCerrarConEscapeYClickAfuera';
import useInertFondo from '../../hooks/useInertFondo';

// Hoja inferior genérica: desliza desde abajo, con manija, header (título + cerrar), cuerpo
// con scroll interno y una acción primaria opcional fija al pie — mismo patrón que pide el
// prompt original para "modales → bottom sheets". A diferencia de DrawerMas/CampanaUnificada
// (pantalla completa, donde el tap-afuera es un no-op porque no hay "afuera" visible), acá SÍ
// queda backdrop visible arriba de la hoja, así que cerrar con tap-afuera tiene sentido real.
// Pensado primero para filtros (ver BotonFiltros/ChipsFiltros), reusable para cualquier otro
// bottom sheet futuro (check-in de turno, alta rápida, etc.).
export default function BottomSheet({ titulo, onCerrar, children, accionPrimaria }) {
    const contenedorRef = useRef(null);
    const tituloRef = useRef(null);

    useCerrarConEscapeYClickAfuera(contenedorRef, true, onCerrar);
    useInertFondo(true);

    useEffect(() => {
        const elementoPrevio = document.activeElement;
        tituloRef.current?.focus();
        return () => {
            if (elementoPrevio && typeof elementoPrevio.focus === 'function') {
                elementoPrevio.focus();
            }
        };
    }, []);

    return (
        <>
            <div className="mob-overlay-backdrop" />
            <div className="mob-bottomsheet" ref={contenedorRef} role="dialog" aria-modal="true" aria-label={titulo}>
                <div className="mob-bottomsheet-manija" aria-hidden="true" />
                <div className="mob-bottomsheet-header">
                    <h2 className="mob-bottomsheet-titulo" ref={tituloRef} tabIndex={-1}>{titulo}</h2>
                    <button type="button" className="mob-sheet-boton-cerrar mob-tocable" onClick={onCerrar} aria-label="Cerrar">
                        <i className="bi bi-x-lg" aria-hidden="true" />
                    </button>
                </div>
                <div className="mob-bottomsheet-body">
                    {children}
                </div>
                {accionPrimaria && (
                    <div className="mob-bottomsheet-footer">
                        <button
                            type="button"
                            className="mob-bottomsheet-boton-primario mob-tocable"
                            onClick={accionPrimaria.onClick}
                            disabled={accionPrimaria.disabled}
                        >
                            {accionPrimaria.label}
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}
